import {
  Accordion,
  AccordionSummary,
  Box,
  Button,
  Container,
  Divider,
  Typography,
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChangePasswordCard from './Component/ChangePasswordCard';
import ChangePhoneNumberCard from './Component/ChangePhoneNumberCard';

const ChangeCredentials = () => {
  const naviagte = useNavigate();

  return (
      <Container
        maxWidth='true'
        sx={{ pl: '2rem', pt: '5rem' }}
      >
        <Typography variant='h4'>Change Credentials</Typography>

        <Divider sx={{ mt: '1rem', mb: '3rem' }} />
        <ChangePasswordCard />
        <ChangePhoneNumberCard />
      </Container>
  );
};

export default ChangeCredentials;
